import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "antd";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";

/**
 * Màn hình nhận kết quả sau khi Facebook OAuth hoàn tất — route /facebook/callback-status.
 *
 * Luồng chuyển hướng cả tab: người dùng rời khỏi CMS sang Facebook cấp quyền, backend xử lý
 * xong thì redirect về đây kèm query:
 *   status      success | error
 *   account_id  ID tài khoản OAuth (khi thành công)
 *   message     nội dung lỗi (khi thất bại)
 *
 * Thành công thì tự đưa người dùng về /chats sau vài giây, thất bại thì giữ màn hình
 * để họ đọc lỗi rồi tự bấm quay lại kết nối.
 */

const AUTO_BACK_SECONDS = 3;

export default function FacebookCallbackStatus() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const status = params.get("status");
    const errorMessage = params.get("message");
    const success = status === "success";
    const [countdown, setCountdown] = useState(AUTO_BACK_SECONDS);

    useEffect(() => {
        if (!success) return;
        const tick = setInterval(() => setCountdown((s) => s - 1), 1000);
        const timer = setTimeout(() => navigate("/chats", { replace: true }), AUTO_BACK_SECONDS * 1000);
        return () => {
            clearInterval(tick);
            clearTimeout(timer);
        };
    }, [success, navigate]);

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 text-center max-w-md w-full">

                <div className="mb-4">
                    {success ? (
                        <CheckCircleFilled className="text-5xl text-emerald-500" />
                    ) : (
                        <CloseCircleFilled className="text-5xl text-red-500" />
                    )}
                </div>

                <h1 className="text-xl font-bold text-slate-800 mb-2">
                    {success ? "Liên kết Facebook thành công." : "Liên kết Facebook thất bại"}
                </h1>

                <p className="text-sm text-slate-500">
                    {success
                        ? `Đang quay lại màn hình quản lý kết nối${countdown > 0 ? ` sau ${countdown}s` : ""}...`
                        : (errorMessage || "Không lấy được quyền từ Facebook, vui lòng thử kết nối lại.")}
                </p>

                <Button
                    type="primary"
                    className="mt-6"
                    onClick={() => navigate("/chats", { replace: true })}
                >
                    {success ? "Quay lại ngay" : "Thử kết nối lại"}
                </Button>

            </div>
        </div>
    );
}
